import React from 'react';
import { useTranslation } from 'react-i18next';
import { KatButton, KatColumn, KatDivider, KatRow } from '@amzn/katal-react';
import { AuthenticationState } from '../hooks/useTrimContext';

const RetractEscalate = React.lazy(() =>
  import(
    /* webpackChunkName: 'RetractEscalate' */ '@amzn/rav-retract-escalate-components/dist'
  ).then((library) => ({ default: library.RetractEscalate }))
);

interface PNFDisputeLandingPageProps {
  authenticationState?: AuthenticationState;
  routerProps: any;
  userFirstName: string;
}

const PNFDisputeLandingPage: React.FC<PNFDisputeLandingPageProps> = (props: PNFDisputeLandingPageProps) => {
  const { t } = useTranslation(['pnf_website_components', 'pnf_dispute']);
  const {
    authenticationState,
    routerProps,
    userFirstName,
  } = props;

  const handleSignOutClick = () => {
    window.location.href = authenticationState?.signOutUrl || '';
  };

  return (
    <div className="page-padding">
      <KatRow className="d-flex">
        <KatColumn lg={6} md={6} xs={6}>
          <KatRow className="pt-4">
            <h1>
              {t('pnf-dispute-form-title')}
            </h1>
          </KatRow>
          <KatRow className="pt-2">
            <h2>{t('pnf-dispute-description-title')}</h2>
          </KatRow>
          <KatRow>
            {t('pnf-dispute-description-text')}
          </KatRow>
          <KatRow className="pt-3">
            {t('pnf-dispute-description-time-duration')}
          </KatRow>
          <KatRow className="pt-4">
            <KatButton
              id="pnf-website-sign-out-button"
              label={t('public-notice-form-sign-out-button', {
                givenName: userFirstName,
              })}
              variant="tertiary"
              onClick={handleSignOutClick}
            />
          </KatRow>
          <div className="pt-3">
            <KatDivider variant="athens" />
            <RetractEscalate {...routerProps} />
          </div>
        </KatColumn>
      </KatRow>
    </div>
  );
};

export default PNFDisputeLandingPage;
